const POP_UP_AFFECTATION_FACE = {
  actions: {
    fermer: 'Fermer',
  },
  commande: 'Commande',
  date: {
    periodeComplete: 'Du {dateDebut} au {dateFin}',
    dateDebut: 'A partir du {dateDebut}',
  },
};

export default POP_UP_AFFECTATION_FACE;
